var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirmDescription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.5V13H10V14.5H3ZM3 10.5V9H14V10.5H3ZM3 6.5V5H14V6.5H3ZM11.6155 20V17.3578L17.8828 11.1155L20.5152 13.7423L14.2578 20H11.6155ZM12.8078 18.8078H13.7578L17.0038 15.546L16.5443 15.071L16.0788 14.602L12.8078 17.8578V18.8078ZM16.5443 15.071L16.0788 14.602L17.0038 15.546L16.5443 15.071Z",
    fill: "#474F56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirmDescription);
export default __webpack_public_path__ + "static/media/firm-description.04a98b4aa6627abe598edae76335531d.svg";
export { ForwardRef as ReactComponent };